// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 394) return "static/chunks/394-b6be12e662a87467.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 281 ? "8a28b14e" : chunkId) + "." + {"142":"884878597f0073cc","234":"905d7c37ff63c6a0","281":"94121a1e4633cee4","477":"b82ac4a8653d2215","981":"a954ccd3dbd71b18"}[chunkId] + ".js";
};